import moment from 'moment'
import {Avatar} from 'primereact/avatar'
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {Image} from 'primereact/image'
import {useMemo, useState} from 'react'
import {useHistory} from 'react-router-dom'
import {ReactComponent as DuoUserMaps} from '../../assets/icons/DuoMapBookMark.svg'
import {ReactComponent as ShieldIcon} from '../../assets/icons/DuoShield.svg'
import {ReactComponent as UserIcon} from '../../assets/icons/DuoTextLeft.svg'
import {ReactComponent as RightToLeftArrowIcon} from '../../assets/icons/RightToLeftArrow.svg'
import {useAppConfig} from '../../context/app/AppContext'
import TranslateUtils from '../../i18n/TranslateUtils'
import {QueryKeyTypes} from '../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../query-manager/QueryKeysManager'
import {checkEmptyString} from '../../utils/CommonUtils'
import {useQueryParams} from '../../utils/NavigatorUtils'
import {useAuth} from '../authentication/AuthProvider'
import {updateImgList} from '../detail/DetailConstant'
import CustomDetailForm from '../form-utils/CustomDetailForm'
import CustomForm from '../form-utils/CustomForm'
import SecurityDetailForm from '../form-utils/SecurityDetailForm'
import {component, formLayout} from '../form/Constant'
import PageContentWrapper from '../layout/PageContentWrapper'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'
import {patientKeys} from '../patient/PatientConstants'

const PROFILE_PATH = 'authentication'
const QueryProfileDataKey = 'User-Profile'

const queryProfile = 'profile'
const querySecurity = 'security'

// TODO translation
const Profile = () => {
    //#region Context
    const {user, updateCurrentLoggedInUser} = useAuth()
    const {userRole} = useAppConfig()
    //#endregion

    //#region Language
    const {translateCommons, translateKeys} = TranslateUtils()
    //#endregion

    //#region URL Params
    const query = useQueryParams()
    const history = useHistory()
    //#endregion

    //#region Query
    const {profileKeys} = QueryKeyManager(QueryKeyTypes.profile, user?.id)

    const profileQueryKeys = useMemo(() => {
        return profileKeys.detail({id: user?.id})
    }, [profileKeys, user?.id])
    //#endregion

    const getCurrentTabViewIndex = useMemo(() => {
        if (query && !!query?.get('tv')) {
            switch (query.get('tv')) {
                case queryProfile:
                    return 0
                case querySecurity:
                    return 1
                default:
                    return 0
            }
        }
    }, [query])

    const [currentTabView, setCurrentTabView] = useState(
        query?.get('tv') ? getCurrentTabViewIndex : 0,
    )

    const handleOnchange = e => {
        setCurrentTabView(e.index)
        history.push(
            `/information/${user?.id}?tv=${
                e.index === 0
                    ? queryProfile
                    : e.index === 1
                    ? querySecurity
                    : ''
            }`,
        )
    }

    const handleOnSubmit = data => {
        if (
            !data.firstName ||
            data.firstName?.length < 0 ||
            !!checkEmptyString(data.firstName)
        ) {
            showNotification(
                severityNotification.error,
                'First Name is required !!',
            )
            return
        }

        const isValidDate = moment(data.dob, 'DD-MM-YYYY', true).isValid()
        if (!isValidDate) {
            showNotification(
                severityNotification.error,
                'Dob format is invalid. !!',
            )
            return
        }

        let toPostData = {
            ...data,
            active: true,
        }

        updateCurrentLoggedInUser(toPostData)

        setVisibleDialog(false)
    }

    const [visibleDialog, setVisibleDialog] = useState(false)

    const handleUpdateImage = value => {
        let toPostData = {
            ...user,
            ...value,
        }

        updateCurrentLoggedInUser(toPostData)

        setVisibleDialog(false)
        showNotification(
            severityNotification.success,
            'Avatar is updated successfully !!',
        )
    }
    // Sidebar menu config
    const sidebarMenus = [
        {
            key: 'profile',
            label: translateKeys('Profile'),
            icon: <UserIcon className="mr-2" />,
            index: 0,
            submenus: [
                {
                    key: 'basicInformation',
                    label: translateKeys('Basic Information'),
                    icon: <UserIcon width={20} height={20} className="mr-2" />,
                },
                {
                    key: 'contactInformation',
                    label: translateKeys('Contact Information'),
                    icon: (
                        <DuoUserMaps width={20} height={20} className="mr-2" />
                    ),
                },
            ],
        },
        {
            key: 'security',
            label: translateKeys('Security'),
            icon: <ShieldIcon className="mr-2" />,
            index: 1,
            submenus: [
                {
                    key: 'resetPassword',
                    label: translateKeys('Reset Password'),
                    icon: (
                        <ShieldIcon width={20} height={20} className="mr-2" />
                    ),
                },
            ],
        },
    ]

    const dataList = useMemo(() => {
        return [
            {
                key: 'basicInformation',
                children: [
                    {key: patientKeys.profile, component: component.profile},
                ],
                id: 'profile-basic-information',
            },
            {
                key: 'contactInformation',
                children: [
                    {key: patientKeys.address, component: component.address},
                ],
                id: 'profile-contact-information',
            },
        ]
    }, [])

    const handleScrollTo = id => {
        const headerOffset = 80 // height
        const el = document.getElementById(id)
        if (el) {
            const elementPosition =
                el.getBoundingClientRect().top + window.scrollY
            const offsetPosition = elementPosition - headerOffset

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            })
        }
    }

    return (
        <div className="">
            <div className="w-full">
                <PageContentWrapper className="w-full flex">
                    {/* Sidebar */}
                    <div className=" w-22rem sticky-basic-info px-3">
                        <ul className="sidebar-menu">
                            {/* Back to Home */}
                            <li>
                                <Button
                                    icon={
                                        <RightToLeftArrowIcon className="mr-2" />
                                    }
                                    className="sidebar-item styled-title-icon mb-4 font-bold"
                                    onClick={() => history.push('/')}>
                                    {translateKeys('Back to Home')}
                                </Button>
                            </li>
                            {sidebarMenus.map(item => (
                                <div>
                                    <div className="font-semibold text-500  px-2">
                                        {item.label}
                                    </div>
                                    <div>
                                        {item.submenus.map(sub => (
                                            <div
                                                className="font-bold text-600 py-3 flex align-items-center cursor-pointer hover:bg-gray-50 px-2 border-round-lg hover:text-teal-700"
                                                key={sub.key}>
                                                {sub.icon}

                                                {sub.label}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                            {/* {sidebarMenus.map(menu => (
                                <li key={menu.key}>
                                    <Button
                                        icon={menu.icon}
                                        className={`sidebar-item styled-title-icon font-bold ${
                                            currentTabView === menu.index
                                                ? 'active font-bold'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            handleOnchange({index: menu.index})
                                        }>
                                        {menu.label}
                                    </Button>

                                    {currentTabView === menu.index && (
                                        <ul className="sidebar-submenu ml-4 mt-2">
                                            {menu.submenus.map(sub => (
                                                <li
                                                    key={sub.key}
                                                    className="sidebar-subitem"
                                                    onClick={() =>
                                                        handleScrollTo(
                                                            sub.key ===
                                                                'basicInformation'
                                                                ? 'profile-basic-information'
                                                                : sub.key ===
                                                                  'contactInformation'
                                                                ? 'profile-contact-information'
                                                                : sub.key ===
                                                                  'resetPassword'
                                                                ? 'reset-password'
                                                                : '',
                                                        )
                                                    }>
                                                    <span>{sub.label}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))} */}
                        </ul>
                    </div>
                    {currentTabView === 0 && (
                        <div className="p-1 w-full">
                            {/* Profiles */}
                            <div className="profile-header">
                                {/* Cover */}
                                <Image
                                    id="profile-cover"
                                    alt="Image"
                                    src="/images/profile/cover.jpg"
                                />

                                {/* Avatar + Info */}
                                <div className="profile-header">
                                    <div className="profile-avatar-info">
                                        <div
                                            className="profile-avatar-wrapper pointer"
                                            onClick={() =>
                                                setVisibleDialog(true)
                                            }>
                                            <Avatar
                                                id="profile-avatar"
                                                image={
                                                    user?.avatar
                                                        ? user.avatar
                                                        : require('../../assets/images/avatar.png')
                                                }
                                                size="xlarge"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        id="profile-basic-info"
                                        className="mt-4">
                                        <h2 className="font-bold mb-0">
                                            {user?.firstName || ''}{' '}
                                            {user?.lastName || ''}
                                        </h2>
                                        <div className="profile-description-info flex mt-2 flex-wrap md:gap-4">
                                            <p className="m-0 font-thin">
                                                {user?.email || '-'}
                                            </p>
                                            <p className="mt-0 font-thin">
                                                {translateCommons('Joined at')}:{' '}
                                                {user?.createdAt
                                                    ? moment(
                                                          user.createdAt,
                                                      ).format(
                                                          'DD MMM yyyy HH:mm',
                                                      )
                                                    : '-'}
                                            </p>
                                        </div>
                                    </div>
                                    <span
                                        id="profile-edit-button"
                                        className="pointer mt-2"
                                        onClick={() => setVisibleDialog(true)}>
                                        Edit
                                    </span>
                                </div>
                            </div>

                            {/* Profile Information */}
                            <div
                                id="profile-information"
                                className=" col-12 p-0 mt-10rem">
                                {!!user && !!user?.id && (
                                    <CustomDetailForm
                                        profile={true}
                                        initialData={user}
                                        QueryKey={profileQueryKeys}
                                        PATH={PROFILE_PATH}
                                        dataList={dataList}
                                        onSubmit={handleOnSubmit}
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    {currentTabView === 1 && (
                        <div className="p-4 w-full profile-security">
                            <h2 className="font-bold mb-4">
                                {translateKeys('Security')}
                            </h2>
                            {/* Change Password Screen */}
                            <div className="grid col-12 justify-content-center">
                                <SecurityDetailForm />
                            </div>
                        </div>
                    )}
                    {/* Avatar Audit Form */}
                    <Dialog
                        header={
                            <h5 className="mb-0 font-bold">
                                <strong>
                                    {translateKeys('Change Avatar')}
                                </strong>
                            </h5>
                        }
                        breakpoints={{
                            '960px': '75vw',
                            '641px': '100vw',
                        }}
                        style={{width: '40vw'}}
                        visible={visibleDialog}
                        onHide={() => setVisibleDialog(false)}>
                        <CustomForm
                            onSubmit={handleUpdateImage}
                            layout={formLayout.inline}
                            dataList={updateImgList}
                        />
                    </Dialog>
                </PageContentWrapper>
            </div>
            {/* Content */}
        </div>
    )
}

export default Profile
